import { FC, Fragment } from "react";
import { GridApi } from "ag-grid-community";
import { OpportunitiesCount } from "@/components/pages/common/opportunities/components/toolbar/OpportunitiesCount";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";

interface SavingsOpportunitiesTableToolbarLeftSideProps {
  gridApi: GridApi | null;
}

export const SavingsOpportunitiesTableToolbarLeftSide: FC<
  SavingsOpportunitiesTableToolbarLeftSideProps
> = ({ gridApi }) => {
  return (
    <Fragment>
      <OpportunitiesCount gridApi={gridApi} />

      <AgGridAllFiltersChip gridApi={gridApi} />
    </Fragment>
  );
};
